import initApplicationModules from './applicationModule/initRoute'
import initBusinessUnitBrandSelector from './businessUnitBrandSelector/initRoute'
import initBusinessUnitSelector from './businessUnitSelector/initRoute'
import initChangePassword from './changePassword/initRoute'
import initConfirmDelivery from './confirmDelivery/initRoute'
import initDealerSelector from './dealerSelector/initRoute'
import initNetworkOverview from './networkOverview/initRoute'
import initPhysicalProcessWorkshop from './physicalProcessWorkshop/initRoute'
import initSettings from './settings/initRoute'

export default async () => {
    initDealerSelector()
    initBusinessUnitSelector()
    initBusinessUnitBrandSelector()
    initApplicationModules() // Home, Expert and Sales routes
    initSettings() // User and admin settings
    initChangePassword()
    initNetworkOverview()
    initConfirmDelivery()
    initPhysicalProcessWorkshop()
}
